import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/thaat`;

export default class Thaat {
    constructor(thaat = {}) {
        this.thaatMaster = thaat.thaatMaster || [];
    }

    static getThaats = async (token)=>{
        console.log('get all thaats client')
        return  axios.get(`${url}/getthaats`, {headers:{"x-auth-token":token}})
    }

    //api to update thaats
    static putThaats( thaat, token) {
        console.log('put thaats');
        return axios.put(`${url}/changethaats`,thaat, {headers:{"x-auth-token":token}});
    }

     
}